import React from 'react'
import {Route} from 'react-router-dom'
import {push} from 'react-router-redux'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import config from '../../config.js'

import {setRedirectUrl} from 'Skelet/src/modules/fetch.action.js'
import Header from './CoreRouteHeader.js'
import StartFooter from 'Skelet/src/components/Start_Footer.js'


class CoreRoute extends React.Component {

  componentDidMount() {
    if (!this.props.session_token) {
      this.props.setRedirectUrl(this.props.currentURL);
      this.props.redirectToLogin();
    }
  }

  render() {
    if(this.props.session_token) {
      return (
        <div>
          <Header config={config} />
          <main style={{paddingTop:"5em"}}>
            <Route {...this.props} />
          </main>
          <div style={{textAlign:"center"}}><StartFooter lang="EN" /></div>
        </div>
      );
    } else {
      return null
    }
  }

}


function mapStateToProps(state, ownProps) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && state.apiData["login"]["data"]["token"] !== undefined) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    currentURL: ownProps.location.pathname
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    redirectToLogin: () => push('/start'),
    setRedirectUrl,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CoreRoute)



// WEBPACK FOOTER //
// ./src/containers/route-containers/CoreRoute.js